import { render } from "./valid-compent.vue?vue&type=template&id=6c9a12ed"
import script from "./valid-compent.vue?vue&type=script&lang=js"
export * from "./valid-compent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__